import type { Locale } from 'date-fns';
import { format as fnsFormat } from 'date-fns-tz/format';
import { toZonedTime } from 'date-fns-tz/toZonedTime';
import { nb } from 'date-fns/locale/nb';

const osloTimeZone = 'Europe/Oslo';
const defaultLocale = nb;

export class ZonedDate extends Date {
    timeZone: string;

    constructor(date: Date | ZonedDate, zone: string | undefined) {
        if ((date as ZonedDate).timeZone) {
            super(date);
            this.timeZone = (date as ZonedDate).timeZone;
        } else if (!zone) {
            super(toZonedTime(date, osloTimeZone));
            this.timeZone = osloTimeZone;
        } else {
            super(date);
            this.timeZone = zone;
        }
    }
}

export function getZonedDate(
    date: Date | string | undefined = new Date(),
    { timeZone } = { timeZone: osloTimeZone },
): ZonedDate {
    return new ZonedDate(toZonedTime(date, timeZone), timeZone);
}

export function instanceOfZonedDate(object: unknown): object is ZonedDate {
    return typeof object === 'object' && !!object && 'timeZone' in object;
}

export function format(
    date: Date | undefined | string | ZonedDate,
    pattern: string,
    locale: Locale = defaultLocale,
    localTimeZone = false,
): string {
    if (!date) return '';

    const timeZone = localTimeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : osloTimeZone;
    const zonedDate = instanceOfZonedDate(date) ? date : getZonedDate(date, { timeZone });
    return fnsFormat(zonedDate, pattern, { timeZone: zonedDate.timeZone, locale });
}
